module.exports = __webpack_public_path__ + "img/user.bc38b1d6.png";